module.exports = __webpack_public_path__ + "img/female-solid.ebb4cc15.svg";